var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"width50"},[_c('payment-stepper',{on:{"loading":_vm.loading,"error-message":_vm.showError}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }